// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n.button_button_lmpwR {\n    background: none;\n    cursor: pointer;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.button_button_lmpwR:active {\n    background-color: hsla(194, 100%, 50%, 0.35); \n}\n\n.button_highlighted_2c0Ir.button_button_lmpwR {\n    background-color: hsla(194, 100%, 50%, 0.35); \n}\n\n.button_mod-disabled_CFsZ2 {\n    cursor: auto;\n    opacity: .5;\n}\n\n.button_mod-disabled_CFsZ2:active {\n    background: none;\n}\n", ""]);
// Exports
exports.locals = {
	"button": "button_button_lmpwR",
	"highlighted": "button_highlighted_2c0Ir",
	"mod-disabled": "button_mod-disabled_CFsZ2",
	"modDisabled": "button_mod-disabled_CFsZ2"
};
module.exports = exports;
